(() => {
  'use strict';
  const rail = document.querySelector('.hero-products');
  if (!rail) return;
  const items = Array.from(rail.querySelectorAll('.hero-item'));
  let reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const cruise = 55;
  const mod = (n, d) => ((n % d) + d) % d;
  const clamp = (n, lo, hi) => Math.max(lo, Math.min(hi, n));
  let sizes = [], period = 1, overscan = 0, phase = 80, velocity = 0;
  let frame = null, previousTime = 0, visible = true, windowActive = true;
  let hovered = -1, focused = -1, drag = null;
  let pointerX = 0, pointerY = 0, hoverAfter = 0, suppressClick = false;
  let lastWidth = 0, lastHeight = 0;

  // Six original links wrap only outside the viewport. No duplicate focus targets.
  function measure() {
    const width = rail.clientWidth, height = rail.clientHeight;
    if (!width || !height) return;
    const garmentHeight = width < 480 ? 220 : width < 760 ? 260 : 320;
    const scarfWidth = width < 480 ? 420 : width < 760 ? 500 : 620;
    const widths = items.map(el => {
      const img = el.querySelector('img');
      return el.classList.contains('hero-scarf') ? scarfWidth : garmentHeight * Number(img.getAttribute('width')) / Number(img.getAttribute('height'));
    });
    overscan = Math.max(...widths) * .85 + 60;
    const totalWidth = widths.reduce((sum, n) => sum + n, 0);
    const gap = Math.max(width < 760 ? 42 : 76, (width + overscan * 2 - totalWidth) / items.length);
    const oldPeriod = period;
    period = totalWidth + gap * items.length;
    if (lastWidth) phase = phase / oldPeriod * period;
    let start = 28;
    sizes = widths.map((w, i) => {
      const h = items[i].classList.contains('hero-scarf') ? w * 188 / 1340 : garmentHeight;
      const old = sizes[i];
      const size = {width:w, height:h, center:start + w / 2, y:height / 2 + [0,10,-7,8,-8,4][i], scale:old?.scale || 1, fx:old?.fx || 0, fy:old?.fy || 0, angle:old?.angle || 0, shift:old?.shift || 0};
      start += w + gap;
      return size;
    });
    lastWidth = width; lastHeight = height;
    if (reduced.matches) return;
    rail.classList.add('is-moving');
    rail.scrollLeft = 0;
    items.forEach((el, i) => {
      el.style.width = sizes[i].width + 'px';
      el.style.height = sizes[i].height + 'px';
    });
    if (focused >= 0) reveal(focused);
    paint(); wake();
  }
  function center(i) {
    return mod(sizes[i].center - phase + overscan, period) - overscan;
  }
  function reveal(i) {
    if (!sizes.length) return;
    const x = center(i), margin = 35;
    if (x - sizes[i].width * .625 < margin || x + sizes[i].width * .625 > rail.clientWidth - margin) {
      phase += x - rail.clientWidth / 2;
      velocity = 0;
    }
  }
  function activeItem() { return drag ? -1 : focused >= 0 ? focused : hovered; }
  function blocked() {
    return focused >= 0 || hovered >= 0 || document.body.classList.contains('modal-open');
  }
  function paint() {
    if (reduced.matches || !sizes.length) return;
    for (let i = 0; i < items.length; i++) {
      const size = sizes[i];
      const x = center(i) + size.shift;
      const el = items[i];
      el.style.transform = 'translate3d(' + (x - size.width / 2).toFixed(3) + 'px,' + (size.y - size.height / 2).toFixed(3) + 'px,0)';
      el.style.zIndex = size.scale > 1.01 ? '2' : '1';
      el.querySelector('img').style.transform = 'translate3d(' + size.fx.toFixed(3) + 'px,' + size.fy.toFixed(3) + 'px,0) rotate(' + size.angle.toFixed(3) + 'deg) scale(' + size.scale.toFixed(4) + ')';
    }
  }

  function shouldRun() {
    return !reduced.matches && visible && windowActive && !document.hidden && !document.body.classList.contains('modal-open');
  }
  function wake() {
    if (frame === null && shouldRun()) { previousTime = 0; frame = requestAnimationFrame(tick); }
  }
  function stop() {
    if (frame !== null) cancelAnimationFrame(frame);
    frame = null; previousTime = 0;
  }
  function tick(time) {
    frame = null;
    if (reduced.matches && rail.classList.contains('is-moving')) {modeChanged(); return;}
    if (!shouldRun()) return;
    const dt = previousTime ? Math.min((time - previousTime) / 1000, .04) : 1 / 60;
    previousTime = time;
    if (!drag) {
      const target = blocked() ? 0 : cruise;
      const rate = blocked() ? 16 : Math.abs(velocity - cruise) > 100 ? 4.5 : 4;
      velocity += (target - velocity) * (1 - Math.exp(-rate * dt));
      phase = mod(phase + velocity * dt, period);
    }
    const active = activeItem();
    const ease = 1 - Math.exp(-10 * dt);
    let fx = 0, fy = 0;
    if (hovered >= 0 && focused < 0 && !drag) {
      const r = rail.getBoundingClientRect();
      fx = clamp((pointerX - r.left - center(hovered)) / (sizes[hovered].width / 2), -1, 1) * 10;
      fy = clamp((pointerY - r.top - sizes[hovered].y) / (sizes[hovered].height / 2), -1, 1) * 7;
    }
    let settled = Math.abs(velocity) < .03;
    sizes.forEach((size, i) => {
      const selected = i === active && fine.matches;
      const targetScale = selected ? 1.25 : 1;
      let targetShift = 0;
      if (active >= 0 && fine.matches && i !== active) {
        const distance = mod(size.center - sizes[active].center + period / 2, period) - period / 2;
        targetShift = Math.sign(distance) * (sizes[active].width * .08 + 8) * Math.exp(-Math.max(0, Math.abs(distance) - 500) / 1000);
      }
      const tx = selected ? fx : 0, ty = selected ? fy : 0;
      const targetAngle = selected ? fx / 10 : 0;
      size.angle += (targetAngle - size.angle) * ease;
      size.scale += (targetScale - size.scale) * ease;
      size.shift += (targetShift - size.shift) * ease;
      size.fx += (tx - size.fx) * ease; size.fy += (ty - size.fy) * ease;
      if (Math.abs(size.angle - targetAngle) > .002 || Math.abs(size.scale - targetScale) > .0001 || Math.abs(size.shift - targetShift) > .02 || Math.abs(size.fx - tx) + Math.abs(size.fy - ty) > .03) settled = false;
    });
    paint();
    if (!blocked() || drag || !settled) frame = requestAnimationFrame(tick);
  }

  function clearHover() { hovered = -1; wake(); }
  rail.addEventListener('pointermove', e => {
    pointerX = e.clientX; pointerY = e.clientY;
    if (reduced.matches) return;
    if (drag && drag.id === e.pointerId) {
      const dx = e.clientX - drag.startX, dy = e.clientY - drag.startY;
      if (!drag.moved) {
        if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx) && e.pointerType !== 'mouse') { drag = null; wake(); return; }
        if (Math.abs(dx) < 8) return;
        drag.moved = true;
        suppressClick = true;
        hovered = -1; focused = -1;
        rail.classList.add('is-dragging');
        rail.setPointerCapture(e.pointerId);
      }
      const delta = e.clientX - drag.lastX;
      const now = performance.now(), elapsed = Math.max(.008, (now - drag.lastTime) / 1000);
      phase = mod(phase - delta, period);
      velocity = clamp(velocity * .35 - delta / elapsed * .65, -900, 900);
      drag.lastX = e.clientX; drag.lastTime = now;
      e.preventDefault();
      paint(); wake(); return;
    }
    if (fine.matches && e.pointerType === 'mouse' && performance.now() >= hoverAfter) {
      const link = e.target.closest('.hero-item');
      const next = link ? items.indexOf(link) : -1;
      if (hovered !== next) hovered = next;
      wake();
    }
  }, {passive:false});
  rail.addEventListener('pointerleave', () => { if (!drag) clearHover(); });
  rail.addEventListener('pointerdown', e => {
    if (reduced.matches || e.button !== 0) return;
    suppressClick = false;
    drag = {id:e.pointerId, startX:e.clientX, startY:e.clientY, lastX:e.clientX, lastTime:performance.now(), moved:false};
    // Capture only after a horizontal gesture. Vertical touch scrolling stays native.
    wake();
  });
  function finishDrag(e) {
    if (!drag || drag.id !== e.pointerId) return;
    const moved = drag.moved;
    if (moved && performance.now() - drag.lastTime > 100) velocity = 0;
    drag = null;
    rail.classList.remove('is-dragging');
    if (rail.hasPointerCapture(e.pointerId)) rail.releasePointerCapture(e.pointerId);
    if (moved) {clearHover(); hoverAfter = performance.now() + 350;}
    wake();
  }
  addEventListener('pointerup', finishDrag);
  rail.addEventListener('pointercancel', finishDrag);
  rail.addEventListener('lostpointercapture', e => {
    // Touch begins with implicit capture on the image, then transfers to the rail.
    if (e.target === rail) finishDrag(e);
  });
  rail.addEventListener('dragstart', e => e.preventDefault());
  rail.addEventListener('click', e => {
    if (suppressClick && e.detail !== 0) { e.preventDefault(); e.stopPropagation(); suppressClick = false; }
  }, true);
  items.forEach((el, i) => {
    el.querySelector('img').draggable = false;
    el.addEventListener('focus', () => {
      // Pointer focus must not recenter a garment or interrupt drag momentum.
      if (!el.matches(':focus-visible')) return;
      if (document.querySelector('.home-collection').getBoundingClientRect().top <= rail.getBoundingClientRect().bottom) {
        const openingTop = document.querySelector('#main').getBoundingClientRect().top + scrollY;
        scrollTo({top:Math.max(0,openingTop),behavior:'instant'});
        refreshVisibility();
      }
      focused = i; hovered = -1;
      reveal(i); paint(); wake();
    });
    el.addEventListener('blur', () => { if (focused === i) focused = -1; wake(); });
  });
  function modeChanged() {
    stop(); hovered = -1; focused = -1; drag = null; velocity = 0;
    sizes.forEach(size => Object.assign(size,{scale:1,fx:0,fy:0,angle:0,shift:0}));
    rail.classList.remove('is-dragging');
    if (reduced.matches) {
      rail.classList.remove('is-moving');
      items.forEach(el => {el.removeAttribute('style'); el.querySelector('img').removeAttribute('style');});
    } else measure();
  }
  reduced.addEventListener('change', modeChanged);
  // Rebind after the first document render for embedded browser media updates.
  function bindRenderedPreferences() {
    reduced.removeEventListener('change', modeChanged);
    reduced = matchMedia('(prefers-reduced-motion: reduce)');
    reduced.addEventListener('change', modeChanged);
    if (reduced.matches !== !rail.classList.contains('is-moving')) modeChanged();
  }
  if (document.readyState === 'complete') bindRenderedPreferences();
  else addEventListener('load', bindRenderedPreferences, {once:true});
  fine.addEventListener('change', () => {clearHover(); wake();});
  new ResizeObserver(() => {
    if (rail.clientWidth !== lastWidth || rail.clientHeight !== lastHeight) measure();
  }).observe(rail);
  // Sticky content remains in the viewport even when the next section covers it.
  let intersects = true;
  function refreshVisibility() {
    const r = rail.getBoundingClientRect();
    const cover = document.querySelector('.home-collection').getBoundingClientRect();
    const next = intersects && cover.top > r.top;
    if (next === visible) return;
    visible = next;
    if (visible) {velocity = 0; wake();} else {hovered = -1; stop();}
  }
  new IntersectionObserver(entries => {
    intersects = entries[0].isIntersecting;
    refreshVisibility();
  }).observe(rail);
  addEventListener('scroll',refreshVisibility,{passive:true});
  new MutationObserver(() => {if (shouldRun()) wake(); else stop();}).observe(document.body,{attributes:true,attributeFilter:['class']});
  document.addEventListener('visibilitychange', () => {if (document.hidden) stop(); else {velocity = 0; wake();}});
  addEventListener('blur', () => {windowActive = false; drag = null; hovered = -1; rail.classList.remove('is-dragging'); stop();});
  addEventListener('focus', () => {windowActive = true; velocity = 0; wake();});
  modeChanged();
})();
